import { Link } from 'react-router-dom';
import { Button, ButtonProps, IconButton } from '@mui/material';

//
//

type AppButtonProps = ButtonProps & {
  to?: string;
  href?: string;
};

export const AppButton: React.FC<AppButtonProps> = ({ children, to, href, ...props }) => {
  return (
    <Button
      component={to ? Link : href ? 'a' : 'button'}
      size={props?.size || 'small'}
      to={to}
      href={href}
      {...props}
    >
      {children}
    </Button>
  );
};

//
//

type AppIconButtonProps = Omit<ButtonProps, 'variant' | 'color'> & {
  to?: string;
  href?: string;
};

export const AppIconButton: React.FC<AppIconButtonProps> = ({ children, to, href, ...props }) => {
  return (
    <IconButton
      component={to ? Link : href ? 'a' : 'button'}
      size={props?.size || 'small'}
      to={to}
      href={href}
      {...props}
    >
      {children}
    </IconButton>
  );
};
